<template>
  <div>
    <div>
      <div class="container-">
        <!--<div v-for="(item, i) in search.name_details" class="row">-->
        <div class="row-">
          <div class="dedede">
            <div class="icon" style="top: 16px; left: 15px">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.6041 12.4159L18.0875 16.8993C18.2451 17.057 18.3335 17.2708 18.3335 17.4937C18.3334 17.7167 18.2447 17.9304 18.0871 18.088C17.9294 18.2456 17.7155 18.3341 17.4926 18.334C17.2697 18.3339 17.0559 18.2453 16.8983 18.0876L12.415 13.6043C11.0747 14.6423 9.38937 15.1308 7.70174 14.9704C6.01412 14.81 4.451 14.0126 3.33037 12.7406C2.20975 11.4686 1.61579 9.81746 1.66935 8.12307C1.7229 6.42868 2.41993 4.81833 3.61864 3.61962C4.81735 2.4209 6.4277 1.72387 8.12209 1.67032C9.81648 1.61677 11.4676 2.21072 12.7396 3.33135C14.0117 4.45197 14.809 6.01509 14.9694 7.70272C15.1299 9.39034 14.6414 11.0757 13.6033 12.4159H13.6041ZM8.3333 13.3334C9.65938 13.3334 10.9312 12.8067 11.8688 11.869C12.8065 10.9313 13.3333 9.65953 13.3333 8.33345C13.3333 7.00736 12.8065 5.73559 11.8688 4.79791C10.9312 3.86023 9.65938 3.33345 8.3333 3.33345C7.00722 3.33345 5.73545 3.86023 4.79777 4.79791C3.86009 5.73559 3.3333 7.00736 3.3333 8.33345C3.3333 9.65953 3.86009 10.9313 4.79777 11.869C5.73545 12.8067 7.00722 13.3334 8.3333 13.3334Z"
                  fill="#8D8D8D"
                />
              </svg>
            </div>
            <input
              :id="'name-'"
              type="text"
              class="form-control"
              v-model="search.name_details.name"
              :placeholder="
                $t('message.find_partner.ca_search_keyword_placeholder')
              "
              autocomplete="off"
              style="cursor: auto"
            />
            <button
              :class="[
                'btn',
                'btn-success',
                'btn-round',
                'btn-sm',
                'position-relative',
              ]"
              @click="searchComplyAdvantage"
              id="init_ca_search"
            >
              <div
                class="loading loading-button mr-2"
                v-if="search_loading"
                style="margin-top: -2px; left: 16px"
              ></div>
              {{ $t("message.contracts.search") }}
            </button>
          </div>
          <div class="mt-3">
            <button
              class="pl-0 btn btn-link text-button"
              @click="toggleShowSearchParams"
              v-if="!show_search_params"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289Z"
                  fill="#797980"
                /></svg>
                {{ $t("message.comply_advantage.show_additional_params") }}
            </button>
            <button
              class="pl-0 btn btn-link text-button"
              @click="toggleShowSearchParams"
              v-if="show_search_params"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.29289 15.7071C4.90237 15.3166 4.90237 14.6834 5.29289 14.2929L11.2929 8.29289C11.6834 7.90237 12.3166 7.90237 12.7071 8.29289L18.7071 14.2929C19.0976 14.6834 19.0976 15.3166 18.7071 15.7071C18.3166 16.0976 17.6834 16.0976 17.2929 15.7071L12 10.4142L6.70711 15.7071C6.31658 16.0976 5.68342 16.0976 5.29289 15.7071Z"
                  fill="#797980"
                /></svg>
                {{ $t("message.comply_advantage.hide_additional_params") }}
            </button>
          </div>
          <div class="additional_ca_options" v-if="show_search_params">
            <fieldset>
              <legend>
                {{ $t("message.comply_advantage.entity_type_title") }}
              </legend>
              <div class="radio-selector-w-icons">
                <label
                  v-for="(row, rt) in entity_types"
                  class="d-flex align-items-center flex-column justify-content-center"
                  :key="rt"
                >
                  <input
                    type="radio"
                    v-model="search.entity"
                    :value="row.value"
                  />
                  <span v-html="row.icon"></span>
                  {{ row.display_text }}
                </label>
              </div>
            </fieldset>
            <fieldset>
              <legend>
                {{ $t("message.comply_advantage.fuzziness_title") }}
              </legend>
              <div class="range-parent">
                <input
                  type="range"
                  v-model="fuzziness_connector"
                  list="values"
                  step="10"
                />
                <datalist id="values">
                  <option
                    v-for="typ in fuzzy_types"
                    :value="typ.value"
                    :label="typ.value + '%'"
                  ></option>
                </datalist>
                <div class="range-comment">
                  {{ search.fuzziness.display_text }}
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>

    <div v-if="show_no_results" id="no-results-doc">
      <!-- {{noResultsLabel()}} -->
      <div class="card">
        <div class="card-body">
          <div class="position-relative">
            <h2 class="text-center">
              Attis {{ $t("message.find_partner.find_partner") }}
            </h2>
            <button
              class="btn btn-outline-primary position-absolute"
              style="right: 0; top: 0"
              @click="makePdf"
            >
              {{ $t("message.find_partner.download_pdf") }}
            </button>
          </div>
          <h4 class="text-center">
            {{ $t("message.find_partner.search_certificate") }}
          </h4>
          <div class="text-left">
            {{ $t("message.find_partner.search_query") }}:
            {{ no_results_report.content.data.search_term }}
            <!-- {{ no_results_report.content.data.search_term }} -->
          </div>
          <div class="text-left">
            {{ $t("message.find_partner.request_from") }}:
            {{ user_full_name }}
          </div>
          <div class="text-left">
            {{ $t("message.find_partner.request_date") }}:
            {{ no_results_report.content.data.created_at }}
            <!-- {{ no_results_report.content.data.created_at }} -->
          </div>
          <div class="text-left">
            {{ $t("message.find_partner.fuzzyness_no_results") }}:
            {{ no_results_report.content.data.filters.fuzziness }}%
          </div>
          <div>
            {{ $t("message.find_partner.types_no_results") }}:
            <span v-for="type in no_results_report.content.data.filters.types"
              class="badge border-primary border text-primary mr-2 mb-2"
            >
              {{ type }}
            </span>
          </div>
          <div class="text-left">
            {{ $t("message.find_partner.no_matches_line") }}
          </div>
          <div>
            {{ $t("message.find_partner.risk_level_no_results") }}:
            {{ no_results_report.content.data.risk_level }}
          </div>
          <div>
            <b>
              {{ `"${no_results_report.content.data.search_term}" ${$t("message.find_partner.not_found_message")}` }}
            </b>
          </div>
          <h4 class="mt-3 text-left">
            {{ $t("message.find_partner.search_results") }}
          </h4>
          <div
            class="text-left"
            style="border: 1px solid #ccc; padding: 15px; border-radius: 5px"
          >
            {{ $t("message.find_partner.found_matches") }}:
            <span class="badge bg-primary"> 0 </span>
          </div>
        </div>
      </div>
    </div>
    <div v-else id="ca-results">
      <div
        class="hits-header d-flex justify-content-between align-items-center"
        v-if="search_complete"
      >
        <h3>Результаты проверки</h3>
        <pdf
          :user_id="0"
          :document="resp_pdf"
          :goods="[]"
          :doc_id="0"
          source="aml-overall"
          label="Скачать отчеты"
        ></pdf>
      </div>
      <div v-for="hits in grouped_results_hits()" class="row">
        <div
          v-for="hit in hits"
          class="col-lg-4 d-flex align-items-stretch"
          style="padding-top: 10px"
        >
          <div class="card ca-result" :class="hit.checked ? 'checked' : ''">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-12">
                  <label class="ca-checkbox-wrapper">
                    <input type="checkbox" v-model="hit.checked" />
                    <span></span>
                  </label>
                </div>
                <!-- <div class="col-lg-12" >
                                    <div class="card-header card-header-primary" syle="text-align: left; !important">
                                        {{getEntityName(hit.doc.entity_type)}}
                                    </div>
                                </div> -->
              </div>
              <h5 class="btn-link card-title hyperlink" @click="openAML(hit)">
                {{ hit.doc.name }}
              </h5>
              <div class="row">
                <div class="col-lg-12 dalabel">
                  {{ $t("message.comply_advantage.matched_label") }}
                </div>
                <div class="col-lg-12 sanction-labels">
                  <div
                    v-for="tp in hit.doc.types"
                    class="badge"
                    :class="badgeType(getResponseTypeSingle(tp))"
                  >
                    {{ getResponseTypeSingle(tp) }}
                    <span
                      v-if="
                        tp == 'adverse-media' &&
                        hit.doc.adverses &&
                        hit.doc.adverses.length > 0
                      "
                      v-tippy="{ arrow: true, theme: 'light-border' }"
                      :content="prepareTippy(hit.doc.adverses)"
                    >
                      <svg
                        width="14"
                        height="14"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                        <path
                          d="M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-144c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 dalabel">
                  {{ $t("message.comply_advantage.relevance_label") }}
                </div>
                <div class="col-lg-12 davalue">
                  <!--<div v-for="t in hit.match_types"> -->
                  {{ getRelevance(hit.match_types) }},
                  <!--</div> -->
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 dalabel">
                  {{ $t("message.comply_advantage.countries_label") }}
                </div>
                <div class="col-lg-12 davalue">
                  {{ getCountries(hit.doc.fields) }}
                </div>
              </div>
              <div v-if="hit.doc.entity_type == 'person'" class="row">
                <div class="col-lg-12 dalabel">
                  {{ $t("message.comply_advantage.dob_label") }}
                </div>
                <div class="col-lg-12 davalue">
                  {{ getDateOfBirth(hit.doc.fields) }}
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
      <div class="mt-4" v-if="results_hits.length > 20">
        <b-pagination
          v-if="results_hits.length / per_page > 1"
          v-model="page"
          :total-rows="results_hits.length"
          :per-page="per_page"
        ></b-pagination>
      </div>
    </div>
    <b-modal
      id="modal-aml-result"
      :hide-footer="true"
      size="xl"
      :title="
        current_hit && current_hit.doc && current_hit.doc.name
          ? current_hit.doc.name
          : ''
      "
    >
      <div
        v-if="current_hit != false"
        class="main main-really-raised w-50 ml-auto mr-auto"
        :title="getName()"
      >
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="card card-signup no-shadow">
                <div
                  class="card-header card-header-primary negative blue-grad w-50 d-flex justify-content-between align-items-center"
                >
                <div class="dropdown">
                  <button
                    class="btn btn-outline-secondary btn-sm"
                    type="button"
                    id="aml-dropdown"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    :disabled="loading"
                  >
                    {{ $t("message.download") }}&nbsp;&nbsp;
                    <div
                      class="loading loading-button"
                      v-if="loading"
                      style="
                        border-top-width: 2px;
                        border-top-color: #333 !important;
                        top: 30px;
                        right: -93px;
                      "
                    ></div>
                    <div v-else>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M12 2C12.5523 2 13 2.44772 13 3L13 12.5858L16.2929 9.29289C16.6834 8.90237 17.3166 8.90237 17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16C11.7348 16 11.4804 15.8946 11.2929 15.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L11 12.5858L11 3C11 2.44772 11.4477 2 12 2ZM3 14C3.55228 14 4 14.4477 4 15L4 19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20L19 20C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19L20 15C20 14.4477 20.4477 14 21 14C21.5523 14 22 14.4477 22 15L22 19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22L5 22C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19L2 15C2 14.4477 2.44772 14 3 14Z"
                          fill="#333"
                        />
                      </svg>
                    </div>
                  </button>
                  <div class="dropdown-menu" aria-labelledby="aml-dropdown">
                    <a
                      @click="printAML(true)"
                      class="dropdown-item"
                      type="button"
                    >
                      {{ $t("message.contracts.paper_copy") }}
                    </a>
                    <a
                      @click="printAML(false)"
                      class="dropdown-item"
                      type="button"
                    >
                      {{ $t("message.contracts.paper_copy_no_logo") }}
                    </a>
                  </div>
                </div>
                  <div
                    class="togglebutton other mt-md-3 form-label-group d-flex justify-content-start"
                  >
                    <label
                      class="control-label d-flex"
                      style="
                        display: flex !important;
                        flex-wrap: nowrap;
                        flex-direction: column-reverse;
                      "
                    >
                      <input type="checkbox" v-model="show_full" />
                      <span class="toggle"></span>
                      <span style="margin-left: 60px; font-size: 14px">{{
                        $t("message.aml.show_full")
                      }}</span>
                    </label>
                  </div>
                </div>
                <div class="card-body">
                  <article>
                    <b-tabs pills content-class="mt-3" small>
                      <b-tab
                        :title="$t('message.aml.key_data')"
                        lazy
                        v-if="
                          typeof current_hit.doc.aka !== 'undefined' &&
                          current_hit.doc.aka.length > 0
                        "
                      >
                        <div class="well rounded bg-white p-4">
                          <div class="row">
                            <div class="col-3 font-weight-bold subline">
                              {{ $t("message.aml.full_name") }}
                            </div>
                            <div class="col-9 text">
                              {{ current_hit.doc.name }}
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-3 font-weight-bold subline">
                              {{ $t("message.aml.entity_type") }}
                            </div>
                            <div class="col-9 text text-capitalize">
                              {{ current_hit.doc.entity_type }}
                            </div>
                          </div>

                          <div
                            v-if="
                              current_hit.doc.aka &&
                              current_hit.doc.aka.length > 0
                            "
                          >
                            <div class="row">
                              <div class="col-3 font-weight-bold subline">
                                {{ $t("message.aml.aka") }}
                              </div>
                              <div class="col-9 text">
                                <span
                                  v-for="(name, akaindex) in current_hit.doc
                                    .aka"
                                >
                                  <span>{{ name.name }}</span
                                  ><span
                                    v-if="
                                      akaindex < current_hit.doc.aka.length - 1
                                    "
                                    >,
                                  </span>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-3 font-weight-bold subline">
                              {{ $t("message.aml.countries") }}
                            </div>
                            <div class="col-9 text">
                              {{ getCountries(current_hit.doc.fields) }}
                            </div>
                          </div>

                          <div
                            v-if="
                              current_hit.doc.associates &&
                              current_hit.doc.associates.length > 0
                            "
                          >
                            <div class="row">
                              <div class="col-3 font-weight-bold subline">
                                {{ $t("message.aml.associates") }}
                              </div>
                              <div class="col-9 text">
                                <span
                                  v-for="(associate, aindex) in current_hit.doc
                                    .associates"
                                >
                                  <a
                                    href="#"
                                    @click="doCrossSearch(associate.name)"
                                    >{{
                                      associate.association +
                                      " " +
                                      associate.name
                                    }}</a
                                  ><span
                                    v-if="
                                      aindex <
                                      current_hit.doc.associates.length - 1
                                    "
                                    >,
                                  </span>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div class="row d-none">
                            <div class="col-3 font-weight-bold subline">
                              {{ $t("message.aml.DOB") }}
                            </div>
                            <div class="col-9 text">
                              {{ getDateOfBirth(current_hit.doc.fields) }}
                            </div>
                          </div>

                          <h4 class="mt-3">{{ $t("message.aml.listing") }}</h4>
                          <h5
                            v-if="
                              sortedNodes(current_hit.doc.source_notes)
                                .currently_on.length > 0
                            "
                          >
                            {{ $t("message.aml.currently_on") }}
                          </h5>
                          <div
                            v-for="note in sortedNodes(
                              current_hit.doc.source_notes,
                            ).currently_on"
                            class="mb-3"
                          >
                            <div
                              v-if="
                                typeof note.aml_types !== 'undefined' &&
                                note.aml_types[0] == 'adverse-media'
                              "
                            >
                              <div class="row">
                                <div class="col-3">
                                  <a
                                    :href="note.url"
                                    target="_blank"
                                    class="badge badge-pill badge-warning"
                                    >{{
                                      getResponseTypeSingle(note.aml_types[0])
                                    }}</a
                                  >
                                </div>
                                <div class="col-9 subtitle">
                                  <span
                                    v-if="
                                      note.country_codes &&
                                      note.country_codes.length > 0
                                    "
                                  >
                                    <img
                                      v-for="flag in getFlags(
                                        note.country_codes,
                                      )"
                                      :src="flag.src"
                                      :alt="flag.alt"
                                      :title="flag.alt"
                                    />
                                  </span>
                                  <a :href="note.url" target="_blank">
                                    {{ note.name }}
                                  </a>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-3"></div>
                                <div class="col-3 subline text-muted text-sm">
                                  {{ $t("message.aml.adverse_media_subtype") }}
                                </div>
                                <div class="col-6">
                                  {{ getResponseType(note.aml_types.slice(1)) }}
                                </div>
                              </div>
                              <div class="row" v-if="note.url">
                                <div class="col-3"></div>
                                <div class="col-3 subline text-muted text-sm">
                                  {{ $t("message.aml.related_url") }}
                                </div>
                                <div class="col-6">
                                  <a
                                    :href="note.url"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    >{{ note.url }}</a
                                  >
                                </div>
                              </div>
                              <div v-if="show_full">
                                <div class="row" v-for="detail in note.details">
                                  <div class="col-3"></div>
                                  <div class="col-3 subline text-muted text-sm">
                                    {{ detail.name }}
                                  </div>
                                  <div class="col-6">{{ detail.value }}</div>
                                </div>
                              </div>
                              <br />
                            </div>

                            <div v-else>
                              <div class="row" v-if="note.aml_types">
                                <div class="col-3">
                                  <a
                                    :href="note.url"
                                    target="_blank"
                                    class="badge badge-pill badge-warning"
                                    >{{
                                      getResponseTypeSingle(note.aml_types[0])
                                    }}</a
                                  >
                                </div>
                                <div class="col-9 subtitle">
                                  <span
                                    v-if="
                                      note.country_codes &&
                                      note.country_codes.length > 0
                                    "
                                  >
                                    <img
                                      v-for="flag in getFlags(
                                        note.country_codes,
                                      )"
                                      :src="flag.src"
                                      :alt="flag.alt"
                                      :title="flag.alt"
                                    />
                                  </span>
                                  <a :href="note.url" target="_blank">{{
                                    note.name
                                  }}</a>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-3"></div>
                                <div class="col-3 subline text-sm text-muted">
                                  <span class=""
                                    ><svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      height="1em"
                                      viewBox="0 0 512 512"
                                    >
                                      <path
                                        d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
                                      /></svg></span>
                                  {{ $t("message.aml.created_at") }}
                                </div>
                                <div class="col-6">
                                  {{ momentum(note.listing_started_utc) }}
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-3"></div>
                                <div class="col-3 subline text-sm text-muted">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentcolor"
                                    height="1em"
                                    viewBox="0 0 640 512"
                                  >
                                    <path
                                      d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
                                    />
                                  </svg>
                                  {{ $t("message.aml.related_url") }}
                                </div>
                                <div class="col-6">
                                  <a
                                    :href="note.url"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    >{{ note.url }}</a
                                  >
                                </div>
                              </div>
                              <div v-if="show_full">
                                <div class="row" v-for="detail in note.details">
                                  <div class="col-3"></div>
                                  <div class="col-3 subline text-muted text-sm">
                                    {{ detail.name }}
                                  </div>
                                  <div
                                    class="col-6"
                                    v-if="detail.name == 'Related URL'"
                                  >
                                    <a target="_blank" :href="detail.value">{{
                                      detail.value
                                    }}</a>
                                  </div>
                                  <div class="col-6" v-else>
                                    {{ detail.value }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <h5
                            v-if="
                              sortedNodes(current_hit.doc.source_notes)
                                .removed_from.length > 0
                            "
                          >
                            {{ $t("message.aml.removed_from") }}
                          </h5>
                          <div
                            v-for="note in sortedNodes(
                              current_hit.doc.source_notes,
                            ).removed_from"
                            class="mb-3"
                          >
                            <div
                              v-if="
                                typeof note.aml_types !== 'undefined' &&
                                note.aml_types[0] == 'adverse-media'
                              "
                            >
                              <div class="row">
                                <div class="col-3">
                                  <a
                                    :href="note.url"
                                    target="_blank"
                                    class="badge badge-pill badge-warning"
                                    >{{
                                      getResponseTypeSingle(note.aml_types[0])
                                    }}</a
                                  >
                                </div>
                                <div class="col-9 subtitle">
                                  <span
                                    v-if="
                                      note.country_codes &&
                                      note.country_codes.length > 0
                                    "
                                  >
                                    <img
                                      v-for="flag in getFlags(
                                        note.country_codes,
                                      )"
                                      :src="flag.src"
                                      :alt="flag.alt"
                                      :title="flag.alt"
                                    />
                                  </span>
                                  <a :href="note.url" target="_blank">
                                    {{ note.name }}
                                  </a>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-3"></div>
                                <div class="col-3 subline text-muted text-sm">
                                  {{ $t("message.aml.adverse_media_subtype") }}
                                </div>
                                <div class="col-6">
                                  {{ getResponseType(note.aml_types.slice(1)) }}
                                </div>
                              </div>
                              <div class="row" v-if="note.url">
                                <div class="col-3"></div>
                                <div class="col-3 subline text-muted text-sm">
                                  {{ $t("message.aml.related_url") }}
                                </div>
                                <div class="col-6">
                                  <a
                                    :href="note.url"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    >{{ note.url }}</a
                                  >
                                </div>
                              </div>
                              <div v-if="show_full">
                                <div class="row" v-for="detail in note.details">
                                  <div class="col-3"></div>
                                  <div class="col-3 subline text-muted text-sm">
                                    {{ detail.name }}
                                  </div>
                                  <div class="col-6">{{ detail.value }}</div>
                                </div>
                              </div>
                              <br />
                            </div>

                            <div v-else>
                              <div class="row" v-if="note.aml_types">
                                <div class="col-3">
                                  <a
                                    :href="note.url"
                                    target="_blank"
                                    class="badge badge-pill badge-warning"
                                    >{{
                                      getResponseTypeSingle(note.aml_types[0])
                                    }}</a
                                  >
                                </div>
                                <div class="col-9 subtitle">
                                  <span
                                    v-if="
                                      note.country_codes &&
                                      note.country_codes.length > 0
                                    "
                                  >
                                    <img
                                      v-for="flag in getFlags(
                                        note.country_codes,
                                      )"
                                      :src="flag.src"
                                      :alt="flag.alt"
                                      :title="flag.alt"
                                    />
                                  </span>
                                  <a :href="note.url" target="_blank">{{
                                    note.name
                                  }}</a>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-3"></div>
                                <div class="col-3 subline text-sm text-muted">
                                  <span class=""
                                    ><svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      height="1em"
                                      viewBox="0 0 512 512"
                                    >
                                      <path
                                        d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
                                      /></svg></span>
                                  {{ $t("message.aml.created_at") }}
                                </div>
                                <div class="col-6">
                                  {{ momentum(note.listing_started_utc) }}
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-3"></div>
                                <div class="col-3 subline text-sm text-muted">
                                  <span class=""
                                    ><svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      height="1em"
                                      viewBox="0 0 512 512"
                                    >
                                      <path
                                        d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
                                      /></svg></span>
                                  {{ $t("message.aml.ended_at") }}
                                </div>
                                <div class="col-6">
                                  {{ momentum(note.listing_ended_utc) }}
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-3"></div>
                                <div class="col-3 subline text-sm text-muted">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentcolor"
                                    height="1em"
                                    viewBox="0 0 640 512"
                                  >
                                    <path
                                      d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
                                    />
                                  </svg>
                                  {{ $t("message.aml.related_url") }}
                                </div>
                                <div class="col-6">
                                  <a
                                    :href="note.url"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    >{{ note.url }}</a
                                  >
                                </div>
                              </div>
                              <div v-if="show_full">
                                <div class="row" v-for="detail in note.details">
                                  <div class="col-3"></div>
                                  <div class="col-3 subline text-muted text-sm">
                                    {{ detail.name }}
                                  </div>
                                  <div
                                    class="col-6"
                                    v-if="detail.name == 'Related URL'"
                                  >
                                    <a target="_blank" :href="detail.value">{{
                                      detail.value
                                    }}</a>
                                  </div>
                                  <div class="col-6" v-else>
                                    {{ detail.value }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--<h4 v-if="show_full" class="mt-3">{{ $t('message.aml.additional_listings') }}</h4>
                                                 <div class="row" v-if="show_full">
                                                    <div class="col-3 font-weight-bold">{{$t('message.aml.field_name')}}</div>
                                                    <div class="col-3 font-weight-bold">{{$t('message.aml.field_source')}}</div>
                                                    <div class="col-6 font-weight-bold">{{$t('message.aml.field_value')}}</div>
                                                </div>
                                                <div v-for="field in current_hit.doc.fields" v-if="show_full">
                                                    <div class="row mb-3">
                                                        <div class="col-3">{{field.name}}</div>
                                                        <div class="col-3">{{hitSourceName(field.source)}}</div>
                                                        <div class="col-6"><span v-if="!isValidUrl(field.value)">{{field.value}}</span><a :href="field.value" target=_blank v-else>{{field.value}}</a></div>
                                                    </div>
                                                </div>    -->
                        </div>
                      </b-tab>
                      <!--<b-tab :title="$t('message.aml.fields')" lazy v-if="typeof current_hit.doc.fields !== 'undefined' && current_hit.doc.fields.length>0">
                                                
                                            </b-tab>-->
                      <b-tab
                        :title="$t('message.aml.media')"
                        lazy
                        v-if="
                          typeof current_hit.doc.media !== 'undefined' &&
                          current_hit.doc.media.length > 0
                        "
                      >
                        <div v-for="media in current_hit.doc.media">
                          <div
                            class="row py-2 px-0 border border-top-0 border-left-0 border-right-0"
                          >
                            <div class="col-12 font-weight-bold">
                              <a
                                :href="media.url"
                                rel="noopener noreferrer"
                                target="_blank"
                                >{{ media.title }}</a
                              >
                              <small>({{ momentum(media.date) }})</small>
                            </div>
                            <div class="col-12">{{ media.snippet }}</div>
                          </div>
                        </div>
                      </b-tab>
                    </b-tabs>
                    <!-- <div v-else> Jonas, something is wrong with this part – v-else without v-if
                                            {{$t('message.aml.noresults')}}
                                        </div> -->
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import html2pdf from "html2pdf.js";
import { isArray } from "util";
export default {
  data() {
    return {
      show_full: false,

      show_no_results: false,

      show_search_params: false,

      no_results_report: {},
      fuzziness_connector: 100,
      search: {
        name_details: {
          name: "",
          reference: "",
          year_of_birth: "",
          country: [],
        },
        entity: 0,
        fuzziness: {
          value: 100,
          display_text: this.$t("message.comply_advantage.fuzzy_100"),
        },
      },
      resp_pdf: {},
      tmp_pdf: {},
      search_complete: false,
      results_hits: [],
      page: 0,
      per_page: 20,
      search_loading: false,
      loading: false,
      contrsearch_country_focus: false,
      fuzziness_focused: false,
      countries: [],
      entity_types: [
        {
          display_text: this.$t("message.comply_advantage.entity_type_all"),
          value: 0,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"/></svg>',
        },
        {
          display_text: this.$t("message.comply_advantage.entity_type_person"),
          value: 1,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"/></svg>',
        },
        {
          display_text: this.$t("message.comply_advantage.entity_type_company"),
          value: 2,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z"/></svg>',
        },
        {
          display_text: this.$t(
            "message.comply_advantage.entity_type_organisation",
          ),
          value: 3,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1.8l18-48H303.8l18 48H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H390.2L254 52.8zM279.8 304H168.2L224 155.1 279.8 304z"/></svg>',
        },
        {
          display_text: this.$t("message.comply_advantage.entity_type_vessel"),
          value: 4,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M192 32c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V64h48c26.5 0 48 21.5 48 48V240l44.4 14.8c23.1 7.7 29.5 37.5 11.5 53.9l-101 92.6c-16.2 9.4-34.7 15.1-50.9 15.1c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-16.2 0-34.7-5.7-50.9-15.1l-101-92.6c-18-16.5-11.6-46.2 11.5-53.9L96 240V112c0-26.5 21.5-48 48-48h48V32zM160 218.7l107.8-35.9c13.1-4.4 27.3-4.4 40.5 0L416 218.7V128H160v90.7zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"/></svg>',
        },
        {
          display_text: this.$t(
            "message.comply_advantage.entity_type_aircraft",
          ),
          value: 5,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"/></svg>',
        },
      ],
      fuzzy_types: [
        {
          display_text: this.$t("message.comply_advantage.fuzzy_exact"),
          value: 0,
        },
        // {display_text: this.$t('message.comply_advantage.fuzzy_0'), value: 0},
        {
          display_text: this.$t("message.comply_advantage.fuzzy_10"),
          value: 10,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_20"),
          value: 20,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_30"),
          value: 30,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_40"),
          value: 40,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_50"),
          value: 50,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_60"),
          value: 60,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_70"),
          value: 70,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_80"),
          value: 80,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_90"),
          value: 90,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_100"),
          value: 100,
        },
      ],
      current_hit: false,
      filters: {},
    };
  },
  watch: {
    fuzziness_connector() {
      let el = this.fuzzy_types.find(
        (item) => item.value == this.fuzziness_connector,
      );
      this.search.fuzziness = el;
    },
    search: {
      deep: true,
      handler() {
        this.saveSearchParams();
        if (this.search.name_details.name !== "") window.is_searched = true;
      },
    },
  },
  methods: {
    getFieldsDetails(key) {
      return this.current_hit.doc.fields.filter((item) => item.source == key);
    },
    sortedNodes(array) {
      let sanction_priority = ["sanction", "warning", "fitness-probity"];
      let entries = Object.entries(array);
      let keys = [];
      let data = [];

      entries.forEach((item) => {
        keys.push(item[0]);
        item[1].details = this.getFieldsDetails(item[0]);
        data.push(item[1]);
      });
      // let keys = Object.keys(array)
      // let data = Object.values(array)
      let bic_enrich = {};
      let has_bic_enrich = false;

      if (keys.includes("bic-enrichment")) {
        bic_enrich = data.splice(
          keys.findIndex((item) => item == "bic-enrichment"),
          1,
        )[0];
        has_bic_enrich = true;
        bic_enrich.aml_types = ["enrichment"];
      }

      let am_media = data.filter((item) => item.name == "company AM");

      data = data
        .filter((item) => item.name !== "company AM")
        .sort((a, b) => {
          let a_type = "";
          let b_type = "";
          if (a.aml_types && a.aml_types.length > 0) a_type = a.aml_types[0];
          else return 1;
          if (b.aml_types && b.aml_types.length > 0) b_type = b.aml_types[0];
          else return 1;

          if (
            sanction_priority.findIndex((item) => item == a_type) >
            sanction_priority.findIndex((item) => item == b_type)
          )
            return 1;
          else return -1;
        });
      data = data.concat(am_media);
      if (has_bic_enrich) data.push(bic_enrich);

      const currently_on = [];
      const removed_from = [];
      data.forEach((item) => {
        if (item.listing_ended_utc) {
          removed_from.push(item);
        } else {
          currently_on.push(item);
        }
      });
      return { currently_on, removed_from };
    },
    getFlagName(country) {
      let result = { display_text: "" };
      let tmp = this.countries.find((c) => c.value == country);
      if (tmp) return tmp;
      return result;
    },
    getFlags(countries) {
      const flags = [];
      countries.forEach((country) =>
        flags.push({
          src: `https://flagsapi.com/${country}/flat/24.png`,
          alt: this.getFlagName(country).display_text,
        }),
      );
      return flags;
    },
    doCrossSearch(search) {
      this.search.name_details.name = search;
      this.searchComplyAdvantage();
      this.$bvModal.hide("modal-aml-result");
    },
    consolelog(data) {
      console.log("note", data);
    },
    grouped_results_hits_paged() {
      let chunks = this.grouped_results_hits();

      console.log(chunks.slice((this.page - 1) * 3, this.page * 3));
      return chunks;
      console.log(chunks);
    },
    toggleShowSearchParams() {
      this.show_search_params = !this.show_search_params;
      this.saveSearchParams();
    },
    saveSearchParams() {
      window.localStorage.setItem("cassp", this.show_search_params ? "1" : "0");
      window.localStorage.setItem("cafuz", this.fuzziness_connector);
      window.localStorage.setItem("caent", this.search.entity);
    },
    loadSearchParams() {
      let show_search_params = window.localStorage.getItem("cassp");

      if (show_search_params == undefined) {
        show_search_params = false;
      }
      if (show_search_params == "0") show_search_params = false;
      if (show_search_params == "1") show_search_params = true;

      this.show_search_params = show_search_params;

      let fuzziness = window.localStorage.getItem("cafuz");
      if (fuzziness == undefined) fuzziness = 100;
      else fuzziness = parseInt(fuzziness);

      this.fuzziness_connector = fuzziness;

      let entity = window.localStorage.getItem("caent");
      if (entity == undefined) entity = 0;
      else entity = parseInt(entity);

      this.search.entity = entity;
    },
    badgeType(type) {
      switch (type) {
        case "Неблагоприятные СМИ":
          return "dabadge-success";
        case "Предупреждение":
          return "dabadge-danger";
        case "Санкции":
          return "dabadge-info";
        case "Киберпреступление":
          return "dabadge-dark";
        default:
          return "dabadge-warning";
      }
    },
    makePdf() {
      var element = document.getElementById("no-results-doc");
      var opt = {
        margin: [0.2, 0.1, 0.2, 0.1],
        filename: "Document_CA_no_match.pdf",
        enableLinks: true,
        //pagebreak:    { mode: 'css', avoid: 'p' },
        pagebreak: { mode: ["avoid-all", "css"] },
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      window.scrollTo(0, 0);
      html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          var totalPages = pdf.internal.getNumberOfPages();
          //print current pdf width & height to consol
          //var imgData = signature.toDataURL('image/png');
          for (var i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            //if(type=='cmr')
            // pdf.addImage(imgData, 'PNG', 12, pdf.internal.pageSize.getHeight()-40)
            //else
            //pdf.addImage(imgData, 'PNG', 0.59, pdf.internal.pageSize.getHeight()-1.37)
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            //divided by 2 to go center
            // if(type=='cmr')
            //     pdf.text(i + ' / ' + totalPages, pdf.internal.pageSize.getWidth()-24, pdf.internal.pageSize.getHeight()-30);
            // else
            //     pdf.text(i + ' / ' + totalPages, pdf.internal.pageSize.getWidth()-1.18, pdf.internal.pageSize.getHeight()-0.59);
          }
        })
        .save();
    },
    prepareTippy(array) {
      const texts = [];
      array.forEach((item) => {
        texts.push(this.$t("message.comply_advantage.response_match_" + item));
      });
      return texts.join("<br>");
    },

    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") this.$data[var_name].push(item);
          });
          // this.$data[var_name] = response.data
        });
    },
    printAML(logo_required = true) {
      this.loading = true;
      this.filters = this.resp_pdf.content.data.filters;
      if (typeof this.resp_pdf.content.data.search_term !== "undefined")
        this.filters.search_term = this.resp_pdf.content.data.search_term;
      var tmp = { ...this.resp_pdf };
      console.log("current hit", this.current_hit);
      setTimeout(() => {
        tmp.content.data.hits[0] = this.current_hit;
        //this.resp_pdf = {};
        this.tmp_pdf = { ...tmp };
      }, 500);

      //this.resp_pdf = tmp;
      console.log("response pdf", this.resp_pdf.content.data.hits[0]);
      setTimeout(() => {
        this.$root.$emit("print-aml", this.tmp_pdf, logo_required);
        setTimeout(() => {
          this.loading = false;
        }, 2000);
      }, 2000);
    },
    removeDetail(index) {
      //this.search.name_details.splice(index, 1);
    },
    add_new_details() {
      // var tmp = {
      //             name: '',
      //             reference: '',
      //             year_of_birth: '',
      //             country: {value: '', display_text: ''}
      //         };
      // this.search.name_details.push(tmp);
    },

    contrsearch_country_Focused() {
      this.contrsearch_country_focus = true;
    },
    contrsearch_countryBlurred() {
      this.contrsearch_country_focus = false;
    },
    comply_fuzziness_focused() {
      this.fuzziness_focused = true;
    },
    comply_fuzziness_blurred() {
      this.fuzziness_focused = false;
    },
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 100);
    },
    findPos(obj) {
      var curleft = 0;
      var curtop = 0;

      if (obj.offsetParent) {
        do {
          curleft += obj.offsetLeft;
          curtop += obj.offsetTop;
        } while ((obj = obj.offsetParent));

        return { X: curleft, Y: curtop };
      }
    },
    searchComplyAdvantage() {
      this.search_loading = true;
      this.show_no_results = false;
      axios.get(window.base + "/account/balance").then((response) => {
        this.user_balance = parseFloat(9999999);
        if (isNaN(this.user_balance)) this.user_balance = 0;
        axios
          .get(window.base + "/admin/GetBillingServiceInfo?code=1")
          .then((response) => {
            let cost = response.data.billing_service_price;

            if (this.$store.state.user.is_privileged)
              cost = response.data.service_price_privileged;
            if (cost == undefined) cost = 0;
            if (this.user_balance < cost || this.user_balance <= 0) {
              this.$bvModal.msgBoxOk(
                this.$t("message.account.not_enough_funds_message"),
                {
                  title: this.$t("message.confirm"),
                  size: "md",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                },
              );
            } else {
              this.$bvModal
                .msgBoxConfirm(
                  this.$t("message.contracts.check_contragent_price_alert") +
                    " " +
                    window.rubFormat(cost, response.data.billing_service_cur),
                  {
                    title: this.$t("message.confirm"),
                    size: "md",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: this.$t("message.yes"),
                    cancelTitle: this.$t("message.no"),
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                  },
                )
                .then((value) => {
                  if (value) {
                    let fd = new FormData();

                    fd.append("amount", cost);
                    fd.append("service_code", 1);
                    axios.post(window.base + "/account/reduceBalance", fd);
                    this.$root.$emit("reduceBalance", { price: cost });
                    var url = window.base + "/document/searchAML";
                    if (window.location.hostname == "attistrade.ru")
                      url =
                        "https://attistrade.kz/api/ca_search?api_key=6e545cff-15ff-4918-9242-f4544653c5ff&api_secret=6911da045dcb36c7ed0e270dc7bed3b670bc1a49149277b29ac02ffc52f6a809";
                    if (window.location.hostname == "attistrade.cn")
                      url =
                        "https://attistrade.kz/api/ca_search?api_key=c507c645-adaa-42e6-9e80-c4d088452827&api_secret=6911da045dcb36c7ed0e270dc7bed3b670bc1a49149277b29ac02ffc52f6a809";
                    axios.post(url, this.search).then((response) => {
                      if (
                        Array.isArray(response.data.content.data.hits) &&
                        response.data.content.data.hits.length > 0
                      ) {
                        if (
                          typeof response.data.content.data.filters
                            .entity_type !== "undefined"
                        ) {
                          response.data.content.data.hits =
                            response.data.content.data.hits.filter(
                              (hit) =>
                                hit.doc.entity_type ===
                                response.data.content.data.filters.entity_type,
                            );
                        }
                        this.results_hits = this.prepare(
                          response.data.content.data.hits,
                        );
                        if (response.data.content.data.total_hits > 100) {
                          this.loadRest(response.data.content.data.total_hits);
                        } else {
                          this.search_loading = false;
                        }
                        //var element = document.querySelector('#init_ca_search')
                        setTimeout(() => {
                          var element = document.querySelector("#ca-results");
                          var element_pos = this.findPos(element);
                          // element.parentNode.classList.add('error')
                          element.focus();
                          window.scrollTo(0, element_pos.Y - 50);
                        }, 1000);
                        this.search_complete = true;
                        this.resp_pdf = response.data;
                      } else {
                        this.show_no_results = true;
                        this.no_results_report = response.data;
                        new Noty({
                          theme: "light",
                          type: "error",
                          text: this.$t(
                            "message.comply_advantage.search_no_results",
                          ),
                          timeout: 5000,
                        }).show();
                      }
                    });
                  }
                });
            }
          });
      });
    },
    loadRest(total_hits) {
      let steps = Math.ceil(total_hits / 100);
      var url = window.base + "/document/searchAML";
      if (window.location.hostname == "attistrade.ru")
        url =
          "https://attistrade.kz/api/ca_search?api_key=6e545cff-15ff-4918-9242-f4544653c5ff&api_secret=6911da045dcb36c7ed0e270dc7bed3b670bc1a49149277b29ac02ffc52f6a809";
      if (window.location.hostname == "attistrade.cn")
        url =
          "https://attistrade.kz/api/ca_search?api_key=c507c645-adaa-42e6-9e80-c4d088452827&api_secret=6911da045dcb36c7ed0e270dc7bed3b670bc1a49149277b29ac02ffc52f6a809";
      for (let i = 1; i < steps; i++) {
        axios
          .post(url, { ...this.search, offset: i * 100 })
          .then((response) => {
            this.results_hits = this.results_hits.concat(
              response.data.content.data.hits,
            );
          });
      }
      this.search_loading = false;
    },
    grouped_results_hits() {
      // return []
      console.log(this.page * 20, (this.page + 1) * 20);
      let necessary_hits = [];
      if (this.page == 0)
        necessary_hits = this.results_hits.slice(
          this.page * 20,
          (this.page + 1) * 20,
        );
      else
        necessary_hits = this.results_hits.slice(
          (this.page - 1) * 20,
          this.page * 20,
        );
      return _.chunk(necessary_hits, 3);
      return _.chunk(this.results_hits, 3);
    },
    saveSearch() {
      // var formData = new FormData();
      // formData.append('org_residency', this.attis_contragents.country.value)
      // formData.append('company_address', this.attis_contragents.city)
      // formData.append('company_main_sphere', this.attis_contragents.sphere)
      // formData.append('org_name', this.attis_contragents.name)
      // formData.append('search_other', this.attis_contragents.search_other)
      // axios.post(window.base + '/contract/saveSearchContr?contact_id='+this.$route.params.id, formData).then(response=>{
      // 	this.loadSavedSearches()
      // })
    },
    getEntityName(entity) {
      return this.$t(
        "message.comply_advantage.response_entity_type_" + entity.trim(),
      );
    },
    getResponseType(types) {
      // var res = '';
      // types.forEach(type => {
      //     res = res + this.$t('message.comply_advantage.response_match_' + type.trim()) + ', ';
      // })
      return types
        .map((type) => {
          return this.$t(
            "message.comply_advantage.response_match_" + type.trim(),
          );
        })
        .join(",");
    },
    getResponseTypeSingle(type) {
      return this.$t("message.comply_advantage.response_match_" + type.trim());
    },
    getRelevance(types) {
      // var res = '';
      // types.forEach(type => {
      //     res = res + this.$t('message.comply_advantage.response_relevance_' + type.trim()) + ', ';
      // })
      return types
        .map((type) => {
          return this.$t(
            "message.comply_advantage.response_relevance_" + type.trim(),
          );
        })
        .join(",");
    },
    getCountries(fields) {
      // var res = fields.map(field => {
      //     return field.value
      // }).join(",");
      // res = res.filter((v, i, a) => a.indexOf(v) === i);
      if (typeof (fields !== "undefined") && _.isArray(fields)) {
        fields = fields.filter((field) => field.name.trim() === "Countries");
        fields = fields.map((field) => {
          return field.value;
        });
        return fields[0];
      }

      return "";
    },
    getOtherFields(fields) {
      // var res = fields.map(field => {
      //     return field.value
      // }).join(",");
      // res = res.filter((v, i, a) => a.indexOf(v) === i);
      if (typeof (fields !== "undefined") && _.isArray(fields)) {
        fields = fields.filter((field) => field.name.trim() === "Other Info");
        // fields = fields.map(field => {
        //     return field.value;
        // });
        return fields;
      }

      return "";
    },
    getDateOfBirth(fields) {
      if (typeof fields !== "undefined" && fields.length > 0) {
        var dobs = fields.filter(
          (field) => field.name.trim() === "Date of Birth",
        );
        if (typeof dobs[0] != "undefined") return dobs[0].value;
      }

      return "";
    },
    openAML(hit) {
      this.current_hit = { ...hit };
      this.$bvModal.show("modal-aml-result");
      //window.open(this.$router.options.base+'#/app/aml/'+this.selected_search_results[i].name, '_blank');
    },
    hitSourceName(str) {
      if (typeof this.current_hit.doc.source_notes[str] !== "undefined")
        return this.current_hit.doc.source_notes[str].name;
      return "";
    },
    isValidUrl(str) {
      var a = document.createElement("a");
      a.href = str;
      return a.host && a.host != window.location.host;
    },
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
    getName() {
      if (this.current_hit) {
        if (
          typeof this.current_hit.doc.aka !== "undefined" &&
          this.current_hit.doc.aka.length > 0
        )
          return this.current_hit.doc.aka[0].name;
      }
      return "";
    },
    do_not_show_again() {
      this.$store.commit("show_kyc_message", false);
      //this.close()
    },
    prepare(hits) {
      return hits.map((item, item_ind) => {
        const n_types = [];
        const adverses = [];
        console.log(item.doc.types);
        item.doc.types.forEach((type, i) => {
          console.log(type, type.indexOf("adverse-media-v2"));
          if (type.indexOf("adverse-media-v2") > -1) {
            console.log("found");
            adverses.push(type);
          } else {
            n_types.push(type);
          }
        });
        item.doc.types = n_types;
        item.doc.adverses = adverses;
        return item;
      });
    },
  },
  mounted() {
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
    window.is_searched = false;
    if (this.$store.state.show_kyc_message !== false) {
      axios
        .get(window.base + "/admin/GetBillingServiceInfo?code=1")
        .then((response) => {
          var locale = this.$i18n.locale;
          var service_name = response.data.billing_service_name_ru;
          switch (locale) {
            case "cn":
              service_name = response.data.billing_service_name_cn;
              break;
            case "en":
              response.data.billing_service_name_en;
              break;
          }
          this.$bvModal
            .msgBoxConfirm(
              this.$t(
                "message.contracts.kyc_service_message",
              ) /*+ ' ' + service_name*/,
              {
                title: service_name,
                size: "md",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: this.$t("message.navigation.never_show_again"),
                cancelTitle: this.$t("message.ok"),
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true,
              },
            )
            .then((value) => {
              this.do_not_show_again();
            });
        });
    }

    this.fetchCountries("");
    this.$root.$on("go_to_ca_search", (data) => {
      console.log("atejo go_to_ca_search");
      console.log(data);
      this.search.name_details.name = data.item.names; // data.item.id
      this.search_loading = true;
      var url = window.base + "/document/GetAMLSearchDetails?id=";
      if (window.location.hostname == "attistrade.ru")
        url =
          "https://attistrade.kz/api/search_details?api_key=6e545cff-15ff-4918-9242-f4544653c5ff&api_secret=6911da045dcb36c7ed0e270dc7bed3b670bc1a49149277b29ac02ffc52f6a809?id=";
      if (window.location.hostname == "attistrade.cn")
        url =
          "https://attistrade.kz/api/search_details?api_key=c507c645-adaa-42e6-9e80-c4d088452827&api_secret=6911da045dcb36c7ed0e270dc7bed3b670bc1a49149277b29ac02ffc52f6a809?id=";
      axios.get(url + data.item.id).then((response) => {
        this.show_no_results = false;
        if (
          Array.isArray(response.data.content.data.hits) &&
          response.data.content.data.hits.length > 0
        ) {
          if (
            typeof response.data.content.data.filters.entity_type !==
            "undefined"
          ) {
            response.data.content.data.hits =
              response.data.content.data.hits.filter(
                (hit) =>
                  hit.doc.entity_type ===
                  response.data.content.data.filters.entity_type,
              );
          }
          this.results_hits = this.prepare(response.data.content.data.hits);
          this.search_loading = false;
          //var element = document.querySelector('#init_ca_search')
          setTimeout(() => {
            var element = document.querySelector("#ca-results");
            var element_pos = this.findPos(element);
            // element.parentNode.classList.add('error')
            element.focus();
            window.scrollTo(0, element_pos.Y - 50);
          }, 1000);
          this.search_complete = true;
          this.resp_pdf = response.data;
        } else {
          this.show_no_results = true;
          this.no_results_report = response.data;
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.comply_advantage.search_no_results"),
            timeout: 5000,
          }).show();
        }
      });

      //this.searchComplyAdvantage();
    });
    this.$root.$on("aml-search-print-aml", () => {
      this.loading = false;
    });

    if (
      this.$route.params &&
      this.$route.params.search &&
      this.$route.params.search !== ""
    ) {
      this.search.name_details.name = this.$route.params.search;
      this.search.entity = this.$route.params.entity;
      this.search.fuzziness = this.$route.params.fuzziness;
      this.searchComplyAdvantage();
    }

    this.loadSearchParams();
  },
  computed: {
    is_bank() {
      return window.is_bank;
    },
    user_full_name() {
      return (
        this.$store.state.user.firstName + " " + this.$store.state.user.lastName
      );
    },
    // aml_disabled(){
    // 	return this.selected_search_results.length==0
    // },
    // selected_search_results(){
    // 	var d = []
    // 	this.contragents_search_results.forEach(item=>{
    // 		if(item.checked===true)
    // 			d.push(item)
    // 	})
    // 	return d
    // }
  },
};
</script>
<style scoped>
.hyperlink {
  cursor: pointer !important;
}
.dedede {
  display: flex;
  gap: 24px;
  position: relative;
}
.dedede input {
  flex-basis: 100%;
  box-shadow:
    0px 12px 32px rgba(0, 0, 0, 0.04),
    0px 8px 24px rgba(0, 0, 0, 0.04),
    0px 2px 8px rgba(0, 0, 0, 0.04),
    0px 0px 1px rgba(0, 0, 0, 0.08);
  border-radius: 30px;
  padding: 14px 44px;
  border: 0;
}
.dedede input::placeholder {
  color: #797980;
}

.dedede button {
  padding: 14px 40px;
  background: linear-gradient(90deg, #259fe2 0%, #46b1e2 100%);
  border-radius: 30px;
  border: 0;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* primary100 */

  color: #ffffff;
}
.dedede .icon {
  position: absolute;
  left: 14px;
  top: 14px;
}
.ca-result {
  /* attis/background blue */

  border: 1px solid #cfebf8;
  border-radius: 20px;
  padding: 20px 24px;
}
.ca-result.checked {
  background: #f9fafa;
  border-color: #f9fafa;
}
.ca-checkbox-wrapper input {
  opacity: 0;
}
.ca-checkbox-wrapper {
  display: block;
}
.ca-checkbox-wrapper span {
  width: 20px;
  height: 20px;
  display: block;

  /* neutral/70 */

  border: 1px solid #b1b1b1;
  border-radius: 99px;
  background-repeat: no-repeat;
  background-position: center;
}
.ca-checkbox-wrapper span:hover {
  background-color: var(--color2);
  border-radius: 99px;
  border: 0;
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='7' viewBox='0 0 10 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.7071 0.292885C10.0976 0.683404 10.0976 1.31657 9.70712 1.7071L4.70712 6.70722C4.51958 6.89476 4.26522 7.00012 4 7.00012C3.73478 7.00012 3.48042 6.89476 3.29289 6.70722L0.292886 3.70716C-0.0976343 3.31663 -0.0976278 2.68347 0.2929 2.29295C0.683429 1.90243 1.31659 1.90243 1.70711 2.29296L4 4.58589L8.29288 0.292902C8.6834 -0.0976272 9.31657 -0.0976349 9.7071 0.292885Z' fill='white'/%3E%3C/svg%3E");
}

.ca-checkbox-wrapper input:checked + span {
  background-color: #ffffff;
  border: 0;
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='7' viewBox='0 0 10 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.7071 0.292885C10.0976 0.683404 10.0976 1.31657 9.70712 1.7071L4.70712 6.70722C4.51958 6.89476 4.26522 7.00012 4 7.00012C3.73478 7.00012 3.48042 6.89476 3.29289 6.70722L0.292886 3.70716C-0.0976343 3.31663 -0.0976278 2.68347 0.2929 2.29295C0.683429 1.90243 1.31659 1.90243 1.70711 2.29296L4 4.58589L8.29288 0.292902C8.6834 -0.0976272 9.31657 -0.0976349 9.7071 0.292885Z' fill='%2347B2E4'/%3E%3C/svg%3E");
}
.ca-result .card-title.hyperlink {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  letter-spacing: 0.1px;

  /* attis/primary10 */

  color: var(--color1);
}
.ca-result .dalabel {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  /* neutral/30 */

  color: #797980;
  margin-bottom: 5px;
  margin-top: 15px;
}
.ca-result .sanction-labels {
  display: flex;
  flex-wrap: wrap;
  gap: 0 10px;
}
.ca-result .davalue {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  /* neutral/10 */

  color: #333333;
}
.ca-result .badge.dabadge-success {
  margin-bottom: 8px;
  padding: 4px 8px;
  gap: 4px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  letter-spacing: 0.1px;

  /* status/success */

  color: #009944;
  /* status/success */

  border: 1px solid #009944;
  border-radius: 8px;
}
.ca-result .badge.dabadge-danger {
  margin-bottom: 8px;
  padding: 4px 8px;
  gap: 4px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  letter-spacing: 0.1px;

  /* status/success */

  color: #e10051;
  /* status/success */

  border: 1px solid #e10051;
  border-radius: 8px;
}
.ca-result .badge.dabadge-info {
  margin-bottom: 8px;
  padding: 4px 8px;
  gap: 4px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  letter-spacing: 0.1px;

  /* status/success */

  color: #4174f6;
  /* status/success */

  border: 1px solid #4174f6;
  border-radius: 8px;
}
.ca-result .badge.dabadge-dark {
  margin-bottom: 8px;
  padding: 4px 8px;
  gap: 4px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  letter-spacing: 0.1px;

  /* status/success */

  color: #333333;
  /* status/success */

  border: 1px solid #333333;
  border-radius: 8px;
}
.ca-result .badge.dabadge-warning {
  margin-bottom: 8px;
  padding: 4px 8px;
  gap: 4px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  letter-spacing: 0.1px;

  /* status/success */

  color: #fe5000;
  /* status/success */

  border: 1px solid #fe5000;
  border-radius: 8px;
}
.hits-header {
  margin-top: 24px;
  margin-bottom: 16px;
}
.hits-header h3 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  /* identical to box height, or 120% */

  /* neutral/10 */

  color: #333333;
}
.additional_ca_options fieldset {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 16px 12px;
  gap: 8px;

  /* neutral/50 */

  border: 1px solid #b1b1b1;
  border-radius: 4px;
}
.additional_ca_options fieldset legend {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  /* neutral/30 */

  color: #797980;
  width: auto;
  padding: 0 5px;
}
.additional_ca_options .radio-selector-w-icons {
  display: flex;
  width: 100%;
}
.additional_ca_options .radio-selector-w-icons label {
  width: 16%;
  flex-basis: 16%;
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 10px;
  text-align: center;
  position: relative;
  padding: 15px 0;
  cursor: pointer;
}
.additional_ca_options .radio-selector-w-icons label input {
  position: absolute;
  opacity: 0;
}
.additional_ca_options .radio-selector-w-icons label span {
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
}
.additional_ca_options
  .radio-selector-w-icons
  label
  input:checked
  + span:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  border: 2px solid var(--color2);
  border-radius: 8px;
}
datalist {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  writing-mode: vertical-lr;
  width: 100%;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  /* neutral/30 */

  color: #797980;
}
.range-parent {
  display: block;
  width: 100%;
}
.range-comment {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  /* neutral/30 */

  color: #797980;
  margin-top: 10px;
}
.range-parent input {
  width: 100%;
}

[type="range"] {
  --range: calc(var(--max) - var(--min));
  --ratio: calc((var(--val) - var(--min)) / var(--range));
  --sx: calc(0.5 * 1.5em + var(--ratio) * (100% - 1.5em));
  margin: 0;
  padding: 0;
  width: 12.5em;
  height: 1.5em;
  background: transparent;
  font:
    1em/1 arial,
    sans-serif;
}
[type="range"],
[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
}
[type="range"]::-webkit-slider-runnable-track {
  box-sizing: border-box;
  border: none;
  width: 12.5em;
  height: 0.25em;
  background: #ccc;
  border-radius: 4px;
}
.js [type="range"]::-webkit-slider-runnable-track {
  background: linear-gradient(#cfebf8, #cfebf8) 0 / var(--sx) 100% no-repeat
    #ccc;
}
[type="range"]::-moz-range-track {
  box-sizing: border-box;
  border: none;
  width: 12.5em;
  height: 0.25em;
  background: #ccc;
  border-radius: 4px;
}
[type="range"]::-ms-track {
  box-sizing: border-box;
  border: none;
  width: 12.5em;
  height: 0.25em;
  background: #ccc;
  border-radius: 4px;
}
[type="range"]::-moz-range-progress {
  height: 0.25em;
  background: #cfebf8;
}
[type="range"]::-ms-fill-lower {
  height: 0.25em;
  background: #cfebf8;
}
[type="range"]::-webkit-slider-thumb {
  margin-top: -0.625em;
  box-sizing: border-box;
  border: none;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  background: #259fe2;
}
[type="range"]::-moz-range-thumb {
  box-sizing: border-box;
  border: none;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  background: #259fe2;
}
[type="range"]::-ms-thumb {
  margin-top: 0;
  box-sizing: border-box;
  border: none;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  background: #259fe2;
}
[type="range"]::-ms-tooltip {
  display: none;
}

.additional_ca_options {
  display: flex;
  gap: 20px;
}
.additional_ca_options fieldset {
  flex-basis: 50%;
}
</style>
<style>
.text-sm {
  font-size: 0.75em;
}
.additional_ca_options .radio-selector-w-icons label span svg {
  width: 18px;
  height: 18px;
  display: block;
  fill: #b1b1b1;
}
.additional_ca_options .radio-selector-w-icons label input:checked + span svg {
  fill: #259fe2;
}
.togglebutton label .toggle::before {
  background: #b1b1b1;
  border: 0;
  height: 22px;
  width: 44px;
}

.togglebutton label .toggle::before {
  background: #b1b1b1 !important;
  border: 0 !important;
  height: 22px !important;
  width: 44px !important;
}
.togglebutton label .toggle::after {
  width: 18px !important;
  height: 18px !important;
  background-color: #fff !important;
  top: 2px !important;
  left: 2px !important;
}
.togglebutton label input:checked ~ .toggle::before {
  background: linear-gradient(90deg, var(--color1) 0%, var(--color2) 100%) !important;
}
.togglebutton label input:checked ~ .toggle::after {
  left: 24px !important;
  transform: unset !important;
}
</style>
